module.exports = __webpack_public_path__ + "img/about-banner.5f0aaf13.jpg";